import PropTypes from 'prop-types';

import {
    CartIconComponent as SourceCartIcon,
} from 'SourceComponent/CartIcon/CartIcon.component';

import './CartIcon.style';

/** @namespace Theme/Component/CartIcon/Component */
export class CartIconComponent extends SourceCartIcon {
    static propTypes = {
        isActive: PropTypes.bool,
    };

    static defaultProps = {
        isActive: false,
    };

    render() {
        const { isActive } = this.props;

        return (
            <svg
              block="CartIcon"
              mods={ { isActive } }
              width="24.931"
              height="29.078"
              viewBox="0 0 24.931 29.078"
              xmlns="http://www.w3.org/2000/svg"
            >
                <rect
                  width="3.227"
                  height="3.227"
                  fill="#00c7fe"
                  transform="translate(9.193 4.812)"
                />
                <ellipse
                  cx="1.614"
                  cy="1.614"
                  rx="1.614"
                  ry="1.614"
                  fill="#fff"
                  transform="translate(6.27 25.851)"
                />
                <ellipse
                  cx="1.614"
                  cy="1.614"
                  rx="1.614"
                  ry="1.614"
                  fill="#fff"
                  transform="translate(17.011 25.851)"
                />
                <path
                  fill="#fff"
                  // eslint-disable-next-line max-len
                  d="M21.828,4.892H13.852v3.16h7.976L19.338,16.1H7.782L5.331,2.617A3.162,3.162,0,0,0,2.276,0H0V3.221H2.276l3.346,18.4a3.158,3.158,0,0,0,3.054,2.536H20.35V20.935H8.677l-.292-1.61H19.319A3.126,3.126,0,0,0,22.3,17.07L24.8,9.018a3.311,3.311,0,0,0-.493-2.832,3.079,3.079,0,0,0-2.484-1.294Z"
                  transform="translate(0 0)"
                />
            </svg>
        );
    }
}

export default CartIconComponent;
